import {Uri} from "../location/uri/uri";
import {NullableString} from "../../../common/types/nullable-types";
import {IStorageService} from "../storage/storage.service.interface";
import {ORBIT_LOCATION_OVERRIDE_BASE} from "../location/location.service";

export const MINI_CIP_BASE_ROUTE = '/cip';
export const MINI_CIS_BASE_ROUTE = '/cis';

export function getMiniOrbitName(storageService: IStorageService): NullableString {
    let basePath = new Uri(new URL(window.location.href)).pathName.getBase().toString();
    if(!isMiniOrbitBasePath(basePath)) {
        basePath = storageService.getItem(ORBIT_LOCATION_OVERRIDE_BASE);
    }

    if(isMiniOrbitBasePath(basePath)) {
        return basePath.replace('/', '');
    }

    return null;
}

export function isMiniOrbitBasePath(basePath: string) {

    if (basePath === MINI_CIP_BASE_ROUTE) {
        return true;
    }

    if (basePath === MINI_CIS_BASE_ROUTE) {
        return true;
    }

    return false;
}

